
    import { Component } from "vue-property-decorator";
    import { mixins } from "vue-class-component";
    import { Button, Modal, Tree } from "ant-design-vue";

    import { getStudioId } from "@/UI/lib/state";
    import { ServicesCategoryStore } from "@/store/modules/ServicesCategory";
    import { ServiceCategoryMix } from "@/UI/mixins/Service/ServiceCategoryMix";
    import { TreeTransfer } from "@/UI/lib/calculte";
    import { UtilsMix } from "@/UI/pages/visitsNew/mixins/UtilsMix"
    import { AppFormsStore } from "@/store/modules/appForms";

    @Component({
        components: {
            "a-button": Button,
            "a-modal": Modal,
            "a-tree": Tree,
        },
    })
    export default class Service extends mixins(ServiceCategoryMix, UtilsMix) {
        showModal: boolean = false;

        servicesTree = new TreeTransfer();
        sData = {};

        async getData(): Promise<void> {
            //await ServiceNomenclatureStore.fetchAll({filter:{salon_id:getStudioId(this)}})
            await ServicesCategoryStore.fetchAll({ filter: { salon_id: getStudioId(this) } });
            await this.ServicesWithCategoriesNew();
        }

        async setShow(): Promise<void> {
            this.showModal = true;
        }

        async modalCancel(): Promise<void> {
            this.showModal = false;
            await this.backToRoute(0);
        }
        async modalOk(): Promise<void> {
            this.showModal = false;

            const data=this.servicesTree.parseData();
            await AppFormsStore.addData(data);
            await AppFormsStore.setReady();
            await this.backToRoute(0);
        }

        async created(): Promise<void> {
            try {
                await this.getData();
            } finally {
                await this.setShow();
            }
        }
        onServiceCheck(checkedKeys: any, info: any): void {
            this.servicesTree.setValue(checkedKeys);
        }
    }
